module.exports = __webpack_public_path__ + "img/project-blog-4.c8b222e6.png";